import React, { useEffect, useState } from 'react'
import { HashRouter } from 'react-router-dom'
import { useRecoilState } from 'recoil'

// eslint-disable-next-line semi
import LayoutPage from './pages/Layout/Layout'
import LoginPage from './pages/Layout/Login'
import LoadingPage from './pages/Layout/LoadingLayout'
import 'antd/dist/antd.css'
import 'react-quill/dist/quill.snow.css'
import { fetch } from './utils/fetch'
import { healthState, userState } from './store'

const App = () => {
  const [verify, setVerify] = useState(false)
  const [verifying, setVerifying] = useState(false)
  const [, setHealth] = useRecoilState(healthState)
  const [, setUser] = useRecoilState(userState)

  useEffect(() => {
    setVerifying(true)
    fetch({ url: '/health' }).then(({ status }) => setHealth(status === 200))

    fetch({ url: '/user/verify' }).then((res) => {
      if (res.data?.success) {
        setUser(res.data?.data)
        setVerify(true)
        setVerifying(false)
        // history.push('/management')
      } else {
        setVerify(false)
        setVerifying(false)
      }
    })
  }, [setHealth, setUser])

  if (verifying) return <LoadingPage />
  return (
    verify ? (
      <HashRouter>
        <LayoutPage />
      </HashRouter>
    )
      : <LoginPage />
  )
}

export default App
